import { render } from "./AllProductGroupsView.vue?vue&type=template&id=4d2d5b7b"
import script from "./AllProductGroupsView.vue?vue&type=script&lang=js"
export * from "./AllProductGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__